"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetSources = void 0;
// this list is exhaustive per the data in the stage+prod `lead_sources` typesense collections
// as of 05/13/2025
exports.SetSources = [
    "setbio",
    "setfan",
    "setlive",
    // deprecated events
    "livestream",
    "nextsong",
    "meetgreet",
    "meetgreetevent",
    "meetgreetevents",
    "settheset",
    "shoutout",
    "shoutouts",
    /**
     * @deprecated - use `setbio` instead
     */
    "set.bio",
];
//# sourceMappingURL=source.js.map